import { keepPreviousData } from "@tanstack/react-query"

import { api } from "~/utils/api"

export function useAllocationInventoryMap(skuIds: string[]) {
  return api.allocation.getAllocationInventoryMap.useQuery(
    { skuIds },
    { enabled: skuIds.length > 0, placeholderData: keepPreviousData },
  )
}
